export const missionAccessControlType = ['manage-missions', 'manage-all-admin-missions'];
export const missionStatuses = ['draft', 'mobilizing', 'inProgress', 'complete', 'closed'];
export const missionStatusesVisibleToVolunteer = ['complete', 'closed'];
export const participantStatuses = ['pending', 'approved', 'deniedRosterFull', 'deniedNotQualified', 'deleted'];
export const shiftAttendanceStatuses = ['checkedIn', 'checkedOut'];
export const participationStatusBadges = ['pending', 'approved', 'deniedRosterFull', 'deniedNotQualified'];
export const displayAddressPermissions = ['fullAddress', 'cityOnly', 'countyOnly'];
export const promoteShiftsMessageType = 'missions-promote-shifts';
export const shiftParticipantActionMessageTypes = {
    approveParticipant: 'missions-approve-participant',
    addParticipant: 'missions-add-participant',
    withdrawParticipant: 'missions-withdraw-participant',
    denyParticipantNotQualified: 'missions-deny-participant-not-qualified',
    denyParticipantRosterFull: 'missions-deny-participant-roster-full',
    participantSelfWithdrawal: 'missions-participant-self-withdrawal',
};
